import * as React from 'react';

import * as styles from './pageAside.css';

export const OfferCardPageLayoutAside = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['aside']}>{props.children}</div>;
};
